import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import Service from '../../../util/Service';

import DateFormat from '../../util/DateFormat';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function BpmnTable() {
    const [lista, setLista] = React.useState();
    const navigate = useNavigate();

    React.useEffect(()=>{
      buscaTodos()
    }, [])
    function showTarefas(tasks){
        let ret = '';
        for(let x in tasks){
            const t = tasks[x];
            let s = t.taskType
            s = s.split("bpmn:").pop();

            ret+= s+", ";
        }
        return ret;
    }
    function buscaCategoria(row){
      if(row && row.lstTask && Array.isArray(row.lstTask)){
        const task = row.lstTask.find(e => e.taskType == "bpmn:Process");
        return task ? task.categorias.join(", ") : "Nenhuma categoria";
      }
      return "Nenhuma categoria";
    }
    function DeletarBpmn(id){
      Service.DELETE("/api/bpmn/"+id).then(r => {
        console.log("Item Removido:", r);
        buscaTodos();
      }).catch( error => {
        console.log("ERROR ao remover:", error)
      })
    }
    function buscaTodos(){
      Service.GET("/api/bpmn/buscaTodos").then( r =>{
        console.log( r);
        setLista(r);
    })
    }
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>Categorias</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Data Criação</TableCell>
            <TableCell align="right">Tarefas</TableCell>
            <TableCell align="right">Edit</TableCell>
            <TableCell align="right">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lista && lista.map((row) => (
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.nome}
              </TableCell>
              <TableCell component="th" scope="row">
                {buscaCategoria(row)}
              </TableCell>
              <TableCell align="right">{row.rodando?'Em execução':'Parado'}</TableCell>
              <TableCell align="right">{ DateFormat.dateAndTimeFormat( row.data ) }</TableCell>
              <TableCell align="right">{showTarefas( row.lstTask)}</TableCell>
              <TableCell align="right">
                <IconButton aria-label="edit" onClick={ (() => navigate('/editBPM/'+row.id))} >
                    <EditIcon />
                </IconButton>
                
              </TableCell>
              <TableCell align="right">
              <IconButton aria-label="edit" onClick={ (() => DeletarBpmn(row.id))} >
                    <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}